var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChargeZone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 82",
    x1: 48.41,
    y1: 7.19,
    x2: 63.93,
    y2: 83.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 82.83,
    y1: 1392.19,
    x2: 44.31,
    y2: 1392.19,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 1434)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 29.43,
    y1: 1394.02,
    x2: 76.97,
    y2: 1394.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1758.44,
    y1: 14577.66,
    x2: 1731.66,
    y2: 14536.06,
    gradientTransform: "matrix(-0.54, -0.84, -0.84, 0.54, 13243.53, -6360.38)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.45,97.66a24.67,24.67,0,0,0-10-4.73A21.2,21.2,0,0,1,10.16,72.32V22A21.18,21.18,0,0,1,31.34.82H81.66A21.18,21.18,0,0,1,102.84,22V72.32A21.2,21.2,0,0,1,86.51,92.93a24.67,24.67,0,0,0-10,4.73L60.46,110.77a6.27,6.27,0,0,1-7.92,0Z",
    fill: "#ff2e2c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.51,10.2H81.66A11.8,11.8,0,0,1,93.46,22V72.32a11.8,11.8,0,0,1-11.8,11.8H31.34a11.8,11.8,0,0,1-11.8-11.8V22.17a12,12,0,0,1,12-12Z",
    fill: "url(#\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_82)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.22,36.26l-.13-.09A.29.29,0,0,0,59.22,36.26Z",
    fill: "#000050"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.55,56.15l.13-.09C60.61,56.09,60.56,56.12,60.55,56.15Z",
    fill: "#000050"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.87,45c5.6-3.84,5.83-5.34,1-9C67,30.09,61.68,28.71,56.31,26.54c7.19,4,16.78,10.23,16,14.62C71,48.12,59,51.38,59,51.38a19.13,19.13,0,0,0,4.23-1.27c1.3-.56,7.12-2.67,10.68-5.11Z",
    fill: "#b21f2d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.72,22.62s3.38,1.58,7.59,3.92C61.68,28.71,67,30.09,74.83,36c4.87,3.66,4.64,5.17-1,9-3.56,2.44-9.38,4.55-10.68,5.11A19.28,19.28,0,0,1,59,51.38,6.94,6.94,0,0,1,56.29,51,14.82,14.82,0,0,0,54,50.33a2.3,2.3,0,0,0-1.19.08l-1.17.37a.66.66,0,0,0-.19.09.34.34,0,0,0-.17.46c.08.31.17.61.27.91,0,.12.07.24.1.37l-.19.06-2.85.92a.68.68,0,0,0-.39.23.59.59,0,0,0,0,.72.57.57,0,0,0,.66.2L51.38,54l.6-.2c.45,1.52.89,3,1.33,4.54l-.16.05-2.95.94a.61.61,0,0,0-.33.94.62.62,0,0,0,.72.18l2.88-.93.18,0,.05.16c.11.39.23.77.34,1.16a.3.3,0,0,0,.28.25.69.69,0,0,0,.32,0c.42-.12.85-.25,1.27-.41a2.5,2.5,0,0,0,.66-.36A6.89,6.89,0,0,0,57.73,59c.42-.53.81-1.07,1.24-1.58a9,9,0,0,1,1.58-1.23s.06,0,.13-.09.66-.24.72-.27c2.59-1.09,5.19-2.14,7.74-3.31a55.75,55.75,0,0,0,7.79-4.22c1.86-1.25,3.94-2.81,4.83-4.94a4.12,4.12,0,0,0,.31-1.09c1.41-9.88-25.34-18.16-33.35-19.61Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.12,27.69c-5.55-3.9-7-3.59-8.77,2.25C32.57,39.38,33.13,44.82,33,50.61c1.22-8.14,3.7-19.3,8.1-20.08,7-1.25,14.23,8.88,14.23,8.88a19,19,0,0,0-2.66-3.51C51.66,34.88,47.65,30.17,44.12,27.69Z",
    fill: "#b21f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.69,44.1c-.62-.79-1.25-1.58-1.87-2.38l-.12-.14.14-.11,1-.72A.31.31,0,0,0,66,40.4a1,1,0,0,0-.13-.29c-.27-.35-.54-.71-.83-1a2.68,2.68,0,0,0-.57-.49,7,7,0,0,0-1.58-.66c-.64-.2-1.28-.37-1.91-.6a9.09,9.09,0,0,1-1.71-1.05.42.42,0,0,1-.13-.09c-.17-.18-.46-.54-.5-.59-1.92-2-3.82-4.1-5.81-6.08a55.26,55.26,0,0,0-6.69-5.82c-1.82-1.3-4-2.7-6.31-2.79a3.9,3.9,0,0,0-1.13.09C28.9,23.12,30.52,51.08,32,59.09c0,0,.29-3.72,1-8.48.15-5.8-.41-11.23,2.37-20.67,1.72-5.85,3.22-6.15,8.77-2.25,3.53,2.47,7.54,7.19,8.53,8.21a18.61,18.61,0,0,1,2.66,3.51,7,7,0,0,1,.56,2.66,15.51,15.51,0,0,0,.19,2.35,2.45,2.45,0,0,0,.49,1.09c.26.32.51.65.76,1l.15.15a.35.35,0,0,0,.49,0l.77-.58.3-.23.13.16L61,48.33a.73.73,0,0,0,.36.29.62.62,0,0,0,.68-.23.57.57,0,0,0,0-.69l-1.63-2.07-.39-.5,3.79-2.84.1.14,1.92,2.43a.61.61,0,0,0,1,0,.63.63,0,0,0-.09-.75Z",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.1,63c-.27,6.78.8,7.87,6.65,6.15,9.44-2.77,13.71-6.18,18.66-9.19C58.9,63.29,48.18,67.25,45.14,64c-4.82-5.19-.24-16.78-.24-16.78a19.06,19.06,0,0,0-1.51,4.14c-.32,1.38-2.11,7.31-2.29,11.61Z",
    fill: "#b21f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.69,35.09,41.7,38s0,.11-.06.18l-.16-.06-1.13-.42a.32.32,0,0,0-.38.07,1.06,1.06,0,0,0-.17.26c-.15.42-.31.84-.44,1.27a3.14,3.14,0,0,0-.09.75,7,7,0,0,0,.29,1.68c.18.64.38,1.28.53,1.93a8.55,8.55,0,0,1,0,2,.31.31,0,0,1,0,.16c0,.24-.2.68-.21.74-.68,2.72-1.39,5.44-2,8.18a56.36,56.36,0,0,0-1.28,8.77c-.1,2.23-.1,4.83,1.07,6.82a4.37,4.37,0,0,0,.69.91c7.07,7,29.71-9.46,35.66-15,0,0-3.29,1.77-7.68,3.74-5,3-9.22,6.42-18.66,9.19-5.85,1.72-6.91.64-6.64-6.15.17-4.3,2-10.23,2.29-11.61A19.06,19.06,0,0,1,44.9,47.2a6.88,6.88,0,0,1,1.93-1.91,15.25,15.25,0,0,0,1.87-1.44,2.4,2.4,0,0,0,.66-1c.13-.39.27-.78.4-1.16a.78.78,0,0,0,0-.21.34.34,0,0,0-.26-.41l-.9-.33-.36-.14.07-.19c.32-.94.64-1.89,1-2.84a.69.69,0,0,0,0-.45.61.61,0,0,0-.56-.45.57.57,0,0,0-.56.41l-.86,2.49-.21.61-4.43-1.65.06-.17c.33-1,.67-2,1-2.92a.59.59,0,1,0-1.13-.35Z",
    fill: "url(#linear-gradient-3)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeZone);
export default __webpack_public_path__ + "static/media/ChargeZone.d547944da6c7e74ff17012143bf94175.svg";
export { ForwardRef as ReactComponent };